import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
/** @type {string} */
import IcFile from "../../assets/icons/ic-file.svg";
import {useStore} from "../../app/store";
import {toast} from "react-toastify";
import {folderFileNameNotAllow, getErrorText} from "../../app/util";
import Input from "../common/Input";
import BtnPlusIcon from "../icons/BtnPlusIcon";

const EntryItem = ({id, path, name, board, type, mutateFoldersAndBookmarks, depth, idx}) => {
    const {appEditorStore, modalStore, folderStore} = useStore();
    const [contextMenuTargetX, setContextMenuTargetX] = useState(0);
    const [contextMenuTargetY, setContextMenuTargetY] = useState(0);
    const [contextOpen, setContextOpen] = useState(false);
    const contextRef = useRef(null);
    const [changeInputVal, setChangeInputVal] = useState("");
    useEffect(() => {
        const handler = async (event) => {
            if (contextRef.current && !contextRef.current.contains(event.target)) {
                setContextOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => {
            document.removeEventListener("mousedown", handler);
        }
    }, []);
    const changeItemNameFunc = async (e) => {
        if (e.nativeEvent.isComposing) return;
        if (folderFileNameNotAllow(changeInputVal)) {
            toast("사용 불가능한 문자가 포함 되어있습니다.");
            return;
        }
        if (changeInputVal !== '') {
            if (changeInputVal === name) {
                toast('현재와 동일한 이름 입니다.');
            } else {
                const fileData = {_id: id, type: type, board: board,}
                try {
                    await folderStore.changeName(type, fileData, changeInputVal);
                    await mutateFoldersAndBookmarks();
                    // folderStore.setCurrentAfterActionInModal(folderStore.editorBoardList.path, 0);
                    toast(`변경 완료되었습니다.`);
                } catch (e) {
                    if (e.code && e.code === "ALREADY_EXIST_FILE_NAME") {
                        toast(getErrorText(e.code));
                    }
                } finally {
                    setCurrentIdx(null);
                }
            }
        } else {
            toast('이름을 입력해주세요.');
        }
    }

    const [currentIdx, setCurrentIdx] = useState(null);
    return (
        <FileWrap
            className={
                `${depth === 0 ? "" : "" ||
                depth === 1 ? "tab-second" : "" ||
                depth === 2 ? "tab-third" : "" ||
                depth === 3 ? "tab-fourth" : ""}`}>
            <div style={{display: "flex", gap: "6px", overflow: "hidden"}} draggable={"true"}
                 onDragStart={async (event) => {
                     event.dataTransfer.setData("fileId", id)
                     appEditorStore.lockClipConnectedBoard(true);
                     await appEditorStore.fileHoverView("");
                 }}
                 onDoubleClick={async () => {
                     if (type === 'COMMON') {
                         await appEditorStore.setCommonBoardEditorData(id, path);
                         if (appEditorStore.commonBoardEditorModal.state) {
                             modalStore.openModal({
                                 ...modalStore.MODAL_PAYLOAD.COMMON_BOARD_PREVIEW(id),
                                 closeFunc: (closeCallback) => {
                                     closeCallback();
                                     appEditorStore.clearCommonBoardEditorModal();
                                 },
                             }, null);
                         }
                     }
                 }}
                 onMouseEnter={async () => {
                     if (type === 'TEMPLATE' || type === 'CLIP' || type === 'CLIP_SET') {
                         await appEditorStore.onFileHoverEvent(id);
                     }
                 }}
                 onMouseLeave={() => {
                     if (type === 'TEMPLATE' || type === 'CLIP' || type === 'CLIP_SET') {
                         appEditorStore.fileHoverOut();
                     }
                 }}
                 onContextMenu={(e) => {
                     e.preventDefault();
                     setContextMenuTargetX(e.clientX);
                     setContextMenuTargetY(e.clientY);
                     setContextOpen(true);
                 }}
            >
                <img src={IcFile} alt={`파일: ${name}`}/>
                <span>{name}</span>
            </div>
            {
                contextOpen &&
                <ContextMenu ref={contextRef} top={contextMenuTargetY} left={contextMenuTargetX}>
                    <div className={"list"} onClick={async () => {
                        setChangeInputVal(name);
                        setContextOpen(false);
                        setCurrentIdx(idx);
                    }}>
                        이름바꾸기
                    </div>
                </ContextMenu>
            }
            {
                // folderStore.getCurrent(type, undefined).files &&
                // folderStore.getCurrent(type, undefined).files.some(item => item._id === currentId) &&
                currentIdx !== null &&
                currentIdx === idx &&
                <Input
                    inputType={"text"}
                    id={"nameChangeInput"}
                    className={`input-name`}
                    placeholder={"이름을 입력해주세요."}
                    autoFocus={true}
                    onChange={(e) => {
                        setChangeInputVal(e.target.value)
                    }}
                    onBlur={async (e) => {
                        // setCurrentIdx(null);
                    }}
                    onKeyDown={async (e) => {
                        if (e.key === "Enter") {
                            await changeItemNameFunc(e);
                        } else if (e.key === "Escape") {
                            setCurrentIdx(null);
                        }
                    }}
                    value={changeInputVal}
                />
            }
            <div className={"add-board"} onClick={async () => {
                await appEditorStore.addBoard(id);
            }}>
                <BtnPlusIcon color={"#949494"}/>
            </div>
        </FileWrap>
    );
};
export default EntryItem;
const ContextMenu = styled.div`
    position: fixed;
    top: ${(props) => props.top + "px"};
    left: ${(props) => props.left + "px"};
    border-radius: 4px;
    z-index: 999999;
    overflow: hidden;
    width: 104px;

    & .list {
        font-weight: 400;
        padding: 3px 12px;
        color: #fff;
        font-size: 12px;
        cursor: pointer;
        background-color: #262626;
        line-height: 1;

        &:hover {
            background-color: #313131;
        }
    }

    & .list:first-child {
        padding: 7px 12px 3px;
    }

    & .list:last-child {
        padding: 3px 12px 7px;
    }
`;
export const FileWrap = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 16px 16px;
    cursor: pointer;
    justify-content: space-between;

    .add-board {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
            width: 14px;
            height: 14px;
        }
    }

    & + div {
        margin: 0 16px 16px;
    }

    img {
        width: 16px;
        pointer-events: none;
    }

    &.tab-second {
        margin-left: 48px;

        span {
            width: 165px;
        }
    }

    &.tab-third {
        margin-left: 73px;

        span {
            width: 145px;
        }
    }

    &.tab-fourth {
        padding-left: 98px;

        span {
            width: 111px;
        }
    }

    span {
        color: var(--Gray-1000_-262626, #262626);
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.13px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .input-name {
        position: absolute;
        top: -5px;
        left: 50%;
        width: 100%;
        transform: translateX(-50%);

        input {
            height: 30px !important;
            font-size: 13px !important;
            font-style: normal;
            font-weight: 400;
        }
    }


    &.tab-second {
        .input-name {
            width: 100%;
            top: -7px;
        }
    }

    &.tab-third {
        .input-name {
            width: 100%;
            top: -7px;
        }
    }

    &.tab-fourth {
        .input-name {
            width: 100%;
            top: -7px;
        }
    }
`;